import { render, staticRenderFns } from "./RequiredTip.vue?vue&type=template&id=1745e7f4&scoped=true"
var script = {}
import style0 from "./RequiredTip.vue?vue&type=style&index=0&id=1745e7f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1745e7f4",
  null
  
)

export default component.exports